import React from "react";
import { Container, Paper,
    AppBar, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import Toolbar from '@mui/material/Toolbar';
import circuitService from "../../service/serviceCircuit";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import SimpleBackdrop from "../../component/loading/loading";
import { Button } from "antd";
import TableCircuit from "../../component/table-circuit/table-circuit";
import DrawerPrincipal from "../../component/drawer/drawer-principal";


function ListCircuit(){

    const [usuario, setUsuario] = useState(null);
    const [permission, setPermission] = useState(null);

    const [listCircuit, setListCircuit] = useState({
        data: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: 10,
            hasNext: false,
            hasPrev: false,
        }
    });

    const [loading, setLoading] = useState(1);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    useEffect(() => {
        try {
            const userToken = localStorage.getItem("user_token");
            if (userToken) {
                const userData = JSON.parse(userToken);
                setUsuario(userData);
                setPermission(userData?.roles?.filter((item) => item.name == "Circuito")[0] || null);
            }
        } catch (error) {
            console.error("Erro ao carregar dados do usuário:", error);
        }
    }, []);

    useEffect(() => {
        if (!usuario) return;

        (async () => {
            setOpen(true);

            try {
                const item = await circuitService.list();

                if (item && item.success !== false) {
                    // Se a API retorna dados paginados
                    if (item.data && Array.isArray(item.data) && item.pagination) {
                        setListCircuit({
                            data: item.data,
                            pagination: item.pagination,
                        });
                    }
                    // Se a API retorna apenas um array (compatibilidade)
                    else if (Array.isArray(item)) {
                        setListCircuit({
                            data: item,
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                    else {
                        console.error("Resposta inválida da API:", item);
                        setListCircuit({
                            data: [],
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                }
                else if (item && item.success === false) {
                    console.error("Erro na API:", item.message);
                    setErrorMessage(item.message);
                    setListCircuit({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
                else {
                    console.error("Resposta inválida da API:", item);
                    setListCircuit({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
            } catch (error) {
                console.error("Erro na requisição:", error);
                setListCircuit({
                    data: [],
                    pagination: {
                        currentPage: 1,
                        totalPages: 0,
                        totalItems: 0,
                        itemsPerPage: 10,
                        hasNext: false,
                        hasPrev: false,
                    }
                });
                setErrorMessage(error.message || "Erro ao carregar circuitos");
            } finally {
                setOpen(false);
                setLoading(0);
            }
        })();
    }, [usuario]);

    const handleClose = () => {
        setOpen(false);
    };

    const loadPage = async (page, pageSize, customFilters, customSortBy, customSortOrder) => {
        // Se customFilters foi passado explicitamente, usa ele; senão usa o estado
        const filtersToUse = customFilters !== undefined ? customFilters : filters;
        const sortByToUse = customSortBy !== undefined ? customSortBy : sortBy;
        const sortOrderToUse = customSortOrder !== undefined ? customSortOrder : sortOrder;
        
        console.log("🔄 [ListCircuit] Carregando página:", page, "Tamanho:", pageSize);
        console.log("🔍 [ListCircuit] customFilters recebido:", customFilters);
        console.log("🔍 [ListCircuit] filters do estado:", filters);
        console.log("🔍 [ListCircuit] Filtros que serão usados:", filtersToUse);
        console.log("📊 [ListCircuit] Ordenação:", sortByToUse, sortOrderToUse);
        
        setOpen(true);
        
        try {
            const item = await circuitService.list(
                page, 
                pageSize, 
                filtersToUse,
                sortByToUse,
                sortOrderToUse
            );
            console.log("📡 [ListCircuit] Resposta da API:", item);
            
            if (item && item.success !== false) {
                if (item.data && Array.isArray(item.data) && item.pagination) {
                    console.log("✅ [ListCircuit] Dados recebidos:", {
                        dataLength: item.data.length,
                        pagination: item.pagination,
                        filters: filtersToUse
                    });
                    setListCircuit({
                        data: item.data,
                        pagination: item.pagination,
                    });
                }
            } else {
                console.error("❌ [ListCircuit] Erro na API:", item);
                setErrorMessage(item?.message || "Erro ao carregar dados");
            }
        } catch (error) {
            console.error("❌ [ListCircuit] Erro ao carregar dados:", error);
            setErrorMessage(error.message || "Erro ao carregar dados");
        } finally {
            setOpen(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        console.log("🔍 [ListCircuit] Filtros alterados:", newFilters);
        console.log("🔍 [ListCircuit] Chamando API IMEDIATAMENTE com novos filtros");
        
        // Atualizar estado
        setFilters(newFilters);
        
        // Recarregar dados com novos filtros IMEDIATAMENTE (não espera setState)
        // Passa newFilters diretamente, não usa o estado
        loadPage(1, listCircuit.pagination.itemsPerPage || 10, newFilters);
    };

    const handleSortChange = (newSortBy, newSortOrder) => {
        console.log("📊 [ListCircuit] Ordenação alterada:", newSortBy, newSortOrder);
        
        // Atualizar estados
        setSortBy(newSortBy);
        setSortOrder(newSortOrder);
        
        // Recarregar dados com nova ordenação
        loadPage(
            listCircuit.pagination.currentPage || 1,
            listCircuit.pagination.itemsPerPage || 10,
            filters,
            newSortBy,
            newSortOrder
        );
    };

    if (!usuario) {
        return (
            <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <SimpleBackdrop open={true} handleClose={() => {}} title={"Carregando usuário..."} />
                </div>
            </Container>
        );
    }

    return (
            <>
                <Container maxWidth="lx" sx={{ bgcolor: '#EBEBEB', height: '100vh' }}>
                    
                    <DrawerPrincipal title={"Circuito"} divOpen={
                        <div>
                            <div>
                                <SimpleBackdrop
                                    open={open}
                                    handleClose={handleClose}
                                    title={"Carregando informações..."}
                                />
                                <div className="row mb-3">
                                    <CustomizedBreadcrumbs title1={"Home"} link1={"/"} 
                                            title2={"Lista de Circuitos"} link2={"#"} />
                                </div>
                                <Paper sx={{width: '100%', margin: 'auto', overflow: 'hidden' }}>
                                    
                                    <AppBar
                                        position="static"
                                        color="default"
                                        elevation={0}
                                        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
                                        >
                                        <Toolbar>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item style={{width: 200}}>
                                                    <h5>Lista de Circuitos</h5>
                                                </Grid>
                                                <Grid item xs>
                                                </Grid>
                                                <Grid item>
                                                </Grid>
                                                <Grid item>
                                                    {
                                                        permission?.isinsert ? 
                                                            <Link to={"/circuit"}>
                                                                <Button style={{background: 'black', color: '#FFF'}}  sx={{ mr: 1 }}>
                                                                    <AddIcon /> Novo
                                                                </Button>
                                                            </Link>
                                                        :
                                                        ""
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Toolbar>
                                    </AppBar>

                                    <div style={{ width: '100%', padding: 10 }}>
                                        {errorMessage && (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    marginBottom: "10px",
                                                    backgroundColor: "#ffebee",
                                                    color: "#c62828",
                                                    border: "1px solid #ef5350",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <strong>Erro:</strong> {errorMessage}
                                            </div>
                                        )}

                                        <TableCircuit 
                                            data={listCircuit} 
                                            onPageChange={loadPage}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                        />
                                    </div>
                            </Paper>
                        </div>
                    </div>
                }/>
            </Container>
        </>
    );
}


export default ListCircuit;